import { Link, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';

// import 'bootstrap/dist/css/bootstrap.min.css';
import './Table.scss';
import './UserDetails.scss';
import { Button } from '../Button';

const UserDetails = (props) => {
  const navigate = useNavigate();
  const userId = useParams('id');
  const storedUsers = JSON.parse(window.localStorage.getItem('users'));

  if (storedUsers === null) {
    return (
      <>
        <div className="error">Can't fetch users from local storage.</div>
        <Link to="/">Main page</Link>
      </>
    );
  }

  const user = storedUsers.find(
    (currentUser) => currentUser.login.uuid === userId.id
  );

  return (
    <div className="user-details">
      <h2>User Details</h2>
      <div className="user-details-container">
        <header className="user-header">
          <h3>
            {user.name.first} {user.name.last}
          </h3>
          <img src={user.picture.large} alt="" />
        </header>

        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>Property</th>
              <th colSpan={3}>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Username</td>
              <td>{user.login.username} </td>
            </tr>
            <tr>
              <td>First name</td>
              <td>{user.name.first}</td>
            </tr>
            <tr>
              <td>Last name</td>
              <td>{user.name.last}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{user.name.title} </td>
            </tr>

            <tr>
              <td>E-mail</td>
              <td>{user.email} </td>
            </tr>
            <tr>
              <td>Gender</td>
              <td>{user.gender} </td>
            </tr>
            <tr>
              <td>Country</td>
              <td>{user.location.country} </td>
            </tr>
            <tr>
              <td>City</td>
              <td>{user.location.city} </td>
            </tr>
            <tr>
              <td>Address</td>
              <td>
                {user.location.street.name} {user.location.street.number}
              </td>
            </tr>
            <tr>
              <td>Postcode</td>
              <td>{user.location.postcode} </td>
            </tr>
            <tr>
              <td>State</td>
              <td>{user.location.state} </td>
            </tr>

            <tr>
              <td>Gender</td>
              <td>{user.gender} </td>
            </tr>
            <tr>
              <td>Birthdate</td>
              <td>{user.dob.date.slice(0, 10)} </td>
            </tr>
            <tr>
              <td>Age</td>
              <td>{user.dob.age} </td>
            </tr>
          </tbody>
        </Table>

        <Button type="button" onClick={() => navigate(-1)}>
          Go back
        </Button>
        <Link className="edit-user-link" to="edit">
          <button type="button">Edit</button>
        </Link>
      </div>
    </div>
  );
};

export default UserDetails;
